export const recycleElectronicsData = [
  {
    Question: `Can you show me how to recycle electronics packaging?`,
    Answer: `Put boxes & cardboard in the recycling container. Foam packing & bubblewrap should go in the trash, not your WM recycling container. Watch our video below for more details.`,
  },
]
